// Обновление страниц без перезагрузки (2026-10-19): одно SSE-соединение на вкладку к
// GET /api/events (server/src/utils/realtime.ts). Событие — «изменился тендер/задача N» или
// «новое уведомление»; страницы подписываются через useRealtime() и сами перечитывают данные.
type Kind = 'tender' | 'task' | 'notification'
type Handler = (ids: (number | null)[]) => void

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const { user } = useAuth()
  const handlers: Record<Kind, Set<Handler>> = { tender: new Set(), task: new Set(), notification: new Set() }
  let es: EventSource | null = null
  let retryTimer: ReturnType<typeof setTimeout> | undefined

  function dispatch(raw: string) {
    let list: { k: Kind; id: number | null }[] = []
    try { list = JSON.parse(raw) } catch { return }
    for (const kind of Object.keys(handlers) as Kind[]) {
      const ids = list.filter(e => e.k === kind).map(e => e.id)
      if (!ids.length) continue
      for (const h of handlers[kind]) {
        try { h(ids) } catch (e) { console.error('[realtime] handler', e) }
      }
    }
  }

  function connect() {
    if (es || typeof EventSource === 'undefined') return
    es = new EventSource(`${config.public.apiBase}/events`, { withCredentials: true })
    es.addEventListener('change', (ev) => dispatch((ev as MessageEvent).data))
    es.onerror = () => {
      // Браузер переподключается сам; если соединение закрыто совсем (401, сервер недоступен) —
      // пробуем снова через 10 с, пока пользователь вошёл
      if (es && es.readyState === EventSource.CLOSED) {
        es = null
        clearTimeout(retryTimer)
        retryTimer = setTimeout(() => { if (user.value) connect() }, 10_000)
      }
    }
  }
  function disconnect() {
    clearTimeout(retryTimer)
    es?.close()
    es = null
  }

  watch(() => user.value?.id, (id) => { id ? connect() : disconnect() }, { immediate: true })

  return {
    provide: {
      realtime: {
        on(kind: Kind, h: Handler) {
          handlers[kind].add(h)
          return () => handlers[kind].delete(h)
        },
      },
    },
  }
})
